var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFirstFour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.969,
    height: 21.981
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-first-four_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#737c81",
    d: "M0 0h16.969v21.981H0z",
    "data-name": "Rectangle 1413"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon - First Four"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#icon-first-four_svg__a)",
    "data-name": "Group 3332"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#ffb100",
    d: "M.75 2.3A1.547 1.547 0 102.3.75 1.547 1.547 0 00.75 2.3",
    "data-name": "Path 5725"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#737c81",
    d: "M6.906 2.297h9.313",
    "data-name": "Line 1251"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#aeb7bc",
    d: "M.75 8.093A1.547 1.547 0 102.3 6.546 1.547 1.547 0 00.75 8.093",
    "data-name": "Path 5726"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#737c81",
    d: "M6.906 8.093h9.313",
    "data-name": "Line 1252"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#737c81",
    d: "M.75 19.684a1.547 1.547 0 101.55-1.547 1.547 1.547 0 00-1.55 1.547",
    "data-name": "Path 5727"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#737c81",
    d: "M6.906 19.684h9.313",
    "data-name": "Line 1253"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#de6627",
    d: "M.75 13.889a1.547 1.547 0 101.55-1.547 1.547 1.547 0 00-1.55 1.547",
    "data-name": "Path 5728"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#737c81",
    d: "M6.906 13.889h9.313",
    "data-name": "Line 1254"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi45NjkiIGhlaWdodD0iMjEuOTgxIj48ZGVmcz48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzczN2M4MSIgZD0iTTAgMGgxNi45Njl2MjEuOTgxSDB6IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxNDEzIi8+PC9jbGlwUGF0aD48L2RlZnM+PGcgZGF0YS1uYW1lPSJJY29uIC0gRmlyc3QgRm91ciI+PGcgZmlsbD0ibm9uZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIgY2xpcC1wYXRoPSJ1cmwoI2EpIiBkYXRhLW5hbWU9Ikdyb3VwIDMzMzIiPjxwYXRoIHN0cm9rZT0iI2ZmYjEwMCIgZD0iTS43NSAyLjNBMS41NDcgMS41NDcgMCAxIDAgMi4zLjc1IDEuNTQ3IDEuNTQ3IDAgMCAwIC43NSAyLjMiIGRhdGEtbmFtZT0iUGF0aCA1NzI1Ii8+PHBhdGggc3Ryb2tlPSIjNzM3YzgxIiBkPSJNNi45MDYgMi4yOTdoOS4zMTMiIGRhdGEtbmFtZT0iTGluZSAxMjUxIi8+PHBhdGggc3Ryb2tlPSIjYWViN2JjIiBkPSJNLjc1IDguMDkzQTEuNTQ3IDEuNTQ3IDAgMSAwIDIuMyA2LjU0NiAxLjU0NyAxLjU0NyAwIDAgMCAuNzUgOC4wOTMiIGRhdGEtbmFtZT0iUGF0aCA1NzI2Ii8+PHBhdGggc3Ryb2tlPSIjNzM3YzgxIiBkPSJNNi45MDYgOC4wOTNoOS4zMTMiIGRhdGEtbmFtZT0iTGluZSAxMjUyIi8+PHBhdGggc3Ryb2tlPSIjNzM3YzgxIiBkPSJNLjc1IDE5LjY4NGExLjU0NyAxLjU0NyAwIDEgMCAxLjU1LTEuNTQ3IDEuNTQ3IDEuNTQ3IDAgMCAwLTEuNTUgMS41NDciIGRhdGEtbmFtZT0iUGF0aCA1NzI3Ii8+PHBhdGggc3Ryb2tlPSIjNzM3YzgxIiBkPSJNNi45MDYgMTkuNjg0aDkuMzEzIiBkYXRhLW5hbWU9IkxpbmUgMTI1MyIvPjxwYXRoIHN0cm9rZT0iI2RlNjYyNyIgZD0iTS43NSAxMy44ODlhMS41NDcgMS41NDcgMCAxIDAgMS41NS0xLjU0NyAxLjU0NyAxLjU0NyAwIDAgMC0xLjU1IDEuNTQ3IiBkYXRhLW5hbWU9IlBhdGggNTcyOCIvPjxwYXRoIHN0cm9rZT0iIzczN2M4MSIgZD0iTTYuOTA2IDEzLjg4OWg5LjMxMyIgZGF0YS1uYW1lPSJMaW5lIDEyNTQiLz48L2c+PC9nPjwvc3ZnPgo=";
export { SvgIconFirstFour as ReactComponent };